import { pipe, transform, string } from 'valibot'

/**
 * string から number に変換するスキーマ
 */
export const stringToNumber = (errorMessage?: string) =>
  pipe(
    string(),
    transform((input) => {
      const toNumber = Number(input)
      if (isNaN(toNumber)) {
        const message_ = errorMessage || `${input} is not a number`
        throw new Error(message_)
      }
      return toNumber
    })
  )
